/**
 * Created by trevor on 2015-03-11.
 */

function PopularPosts() {
    this.extends = [ _ResponsiveTitles, _RSS,];
    this.Formatters = this.Formatters ? this.Formatters : Formatters;
    this.node = null;
    this.id = null;
    this.declaredClass = null;

    this.popular = {
        query: {
            url: 'https://disqus.com/api/3.0/threads/listPopular.json',
            key: '?api_key=sij3aew02xuxxudEOPWhrktnn0oslPHEKl1P81nByt3qS19zjRzJnyP1W4LOvKj1',
            category: '&category=2243810',
            filters: '&interval=90d&limit=100'
        },
        results: []
    };

    this.init = function() {
        $(this.node).show();
        this.getRSS('/rss', $.proxy(this.initPopularPosts, this));
        this.registerResponsiveFunction($.proxy(this.resize, this, "mobile"), 0, window.mogo.registry.mogoUI.config.mediaQueries.small);
        this.registerResponsiveFunction($.proxy(this.resize, this, "tablet"), mogo.registry.mogoUI.config.mediaQueries.small + 1, mogo.registry.mogoUI.config.mediaQueries.medium);
        this.registerResponsiveFunction($.proxy(this.resize, this, "desktop"), mogo.registry.mogoUI.config.mediaQueries.medium + 1, null);
    };

    this.initAllReady = function() {};

    this.initPopularPosts = function() {
        var params = {
            url: this.popular.query.url + this.popular.query.key + this.popular.query.category + this.popular.query.filters,
            dataType: 'json',
            type: 'GET',
            context: document.body,
            success: $.proxy(this._onRequestPopularPostSuccess, this),
            error: $.proxy(this._onRequestPopularPostError, this)
        };
        $.ajax(params);
    };

    this._onRequestPopularPostSuccess = function(json) {
        $(this.node).show();
        var posts = json.response;
        var removeLoader = $.proxy(this.removeLoader, this);
        this.getPostsWithComments(posts);
        this.sortPostsByPopular(this.popular.results);
        this.trimArray(this.popular.results, 5);
        this.setPopularPostData(this.popular.results, function(){
            removeLoader();
        });
    };

    this._onRequestPopularPostError = function(error) {
        console.log('error ' + error);
    };

    this.getPostsWithComments = function(posts) {
        for (i = 0; i < posts.length; i++) {
            if (posts[i].posts > 0) {
                this.popular.results.push(posts[i]);
            }
        }
    };

    this.sortPostsByPopular = function(results) {
        results.sort(function(a, b) {return a.posts - b.posts});
        results.reverse();
    };

    this.setPopularPostData = function(results, callback) {
        var postList = $(this.node).find('ul');

        if (results.length > 0) {
            for (var i = 0; i < results.length; i++) {
                var hideformobile = "";
                var date = this.Formatters.formatDate(results[i].createdAt);
                var postURI = this.parseURLtoURI(results[i].link);
                var post = this.lookupRSSbyURI(postURI);
                var category = this.getPostCategories(post);
                var img = this.getPostImage(post);
                if (i > 2) {
                    hideformobile = " hide-for-small-only";
                }

                postList.append('<li class="row' + hideformobile + '"><a href="' + results[i].link + '"><div class="large-6 medium-12 small-6 columns thumb" style="background-image:url('+ img +')"><div class="cat-meta '+ category +'-icon"></div></div></a><div class="large-6 medium-12 small-6 columns"><div class="date">'+ date +'</div><div class="text"><a href="' + results[i].link + '" class="strong contentContainer">' + results[i].clean_title + '</a></div></div></li>');
            }

            var thumbs = $(".thumb", this.node);
            for (var i = 0; i < thumbs.length; i++) {
                $(thumbs[i]).mogo().create("FeaturedImage", {});
            }
        } else {
            postList.append('<li class="row"><br/>No posts to show</li>');
        }

        callback();
    };

}
